const nurses = [

  {
    id: 1,
    name: "S. Wegener",
    job: "Qualitätsmanagement Buchhaltung",
    img: "url(../../imgs/nurse-1.jpeg)",
  },
  {
    id: 2,
    name: "L. Waal",
    job: "Qualitätsmanagement Abrechnung",
    img: "url(../../imgs/woman.jpg)",
  },
  {
    id: 10,
    name: "N. Merz",
    job: "Praxismanagement",
    img: "url(../../imgs/woman.jpg)",
  },
  {
    id: 3,
    name: "B. Karama",
    job: "Verwaltung Rezeption",
    img: "url(../../imgs/nurse-10.jpeg)",
  },
  {
    id: 4,
    name: "K. Soumah",
    job: "Zahnmedizinische Fachangestellte ",
    img: "url(../../imgs/nurse-3.jpeg)",
  },
  {
    id: 5,
    name: "Y. Amrai",
    job: "Zahnmedizinische Fachangestellte",
    img: "url(../../imgs/nurse-11.jpeg)",
  },
  {
    id: 7,
    name: "M. Amer",
    job: "Zahnmedizinische Fachangestellte ",
    img: "url(../../imgs/nurse-7.jpeg)",
  },


  {
    id: 11,
    name: "T. Aziza",
    job: "Zahnmedizinischer Fachangestellter",
    img: "url(../../imgs/nurse-12.jpeg)",
  },

  {
    id: 8,
    name: "A. Kalanderi",
    job: "Zahntechniker",
    img: "url(../../imgs/nurse-8.jpeg)",
  },


];

export default nurses;
